export type JsonSchema = {
  type?: string;
  properties?: Record<string, JsonSchema>;
  items?: JsonSchema;
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

export const toJsonSchema = (value: unknown): JsonSchema | undefined => {
  if (!isRecord(value)) return undefined;

  const schema: JsonSchema = {};
  if (typeof value.type === 'string') schema.type = value.type;

  if (isRecord(value.properties)) {
    schema.properties = Object.fromEntries(
      Object.entries(value.properties)
        .map(([key, property]) => [key, toJsonSchema(property)])
        .filter(
          (entry): entry is [string, JsonSchema] => entry[1] !== undefined
        )
    );
  }

  const items = toJsonSchema(value.items);
  if (items) schema.items = items;

  return schema;
};

export const getJsonSchemaPropertyNames = (schema: JsonSchema): string[] => {
  if (schema.type === 'object' && schema.properties) {
    return Object.keys(schema.properties);
  }

  if (
    schema.type === 'array' &&
    schema.items?.type === 'object' &&
    schema.items.properties
  ) {
    return Object.keys(schema.items.properties);
  }

  return [];
};
